import {type ButtonProps} from 'react-aria-components'
import {ButtonSize, ButtonVariant} from '../../base/button'
import {CrossIcon} from '../../media/icons/cross-icon'
import Styled from './cross-button.styled'

import type {JSX} from 'react'

export function CrossButton(props: ButtonProps): JSX.Element {
    return (
        <Styled.Button {...props} variant={ButtonVariant.Icon} size={ButtonSize.XS}>
            <CrossIcon />
        </Styled.Button>
    )
}
